export function allocUnsafe(size) {
    return new Uint8Array(size);
}
